/**
 * @generated SignedSource<<679939b45486e6a79c387e6524d90e8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrgAdminTopicsCreateMutation$variables = {
  description: string;
  isPrivate: boolean;
  name: string;
  storeIds: ReadonlyArray<string>;
  teamIds?: ReadonlyArray<string> | null;
};
export type OrgAdminTopicsCreateMutation$data = {
  readonly organisation: {
    readonly createTopic: {
      readonly id: string;
      readonly topics: ReadonlyArray<{
        readonly id: string;
      }> | null;
    };
  };
};
export type OrgAdminTopicsCreateMutation = {
  response: OrgAdminTopicsCreateMutation$data;
  variables: OrgAdminTopicsCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPrivate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storeIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OrgMutation",
    "kind": "LinkedField",
    "name": "organisation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "description",
                "variableName": "description"
              },
              {
                "kind": "Variable",
                "name": "isPrivate",
                "variableName": "isPrivate"
              },
              {
                "kind": "Variable",
                "name": "name",
                "variableName": "name"
              },
              {
                "kind": "Variable",
                "name": "storeIds",
                "variableName": "storeIds"
              },
              {
                "kind": "Variable",
                "name": "teamIds",
                "variableName": "teamIds"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "createTopic",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgAdminTopicsCreateMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrgAdminTopicsCreateMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "6b4e63770d44ed532b7bd05aaf704ae8",
    "id": null,
    "metadata": {},
    "name": "OrgAdminTopicsCreateMutation",
    "operationKind": "mutation",
    "text": "mutation OrgAdminTopicsCreateMutation(\n  $name: String!\n  $description: String!\n  $storeIds: [ID!]!\n  $teamIds: [ID!]\n  $isPrivate: Boolean!\n) {\n  organisation {\n    createTopic(input: {name: $name, description: $description, storeIds: $storeIds, teamIds: $teamIds, isPrivate: $isPrivate}) {\n      id\n      topics {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a2fbe58cf21a028c11a919668efcd61";

export default node;
